<template>
    <div class="hot_div">
        <div class="hot_list">
            <div class="flex_between div_title">
                <h4 class="title">设置</h4>
            </div>
            <div class="members">
                <div class="members_li flex_between">
                    <div class="li_left">
                        <span class="li_title">密码：</span>
                        <span class="li_text">
                            ******
                        </span>
                    </div>
                    <a class="li_right" @click.stop="modify" href="javaScript:void(0)">修改密码</a>
                </div>
                <div class="members_li flex_between">
                    <div class="li_left">
                        <span class="li_title">绑定手机：</span>
                        <span class="li_text">
                            {{user.mobile}}
                        </span>
                    </div>
                    <a class="li_right" href="javaScript:void(0)" @click.stop="dindingFun">更换手机</a>
                </div>
                <div class="members_li flex_between">
                    <div class="li_left flex_between">
                        <span class="li_title">第三方绑定：</span>
                        <span class="li_text flex_center" v-if="user.unionid">
                            <i class="wx"><img :src="user.headimage" alt=""></i>
                            <a href="javaScript:void(0)" @click="remove_dinding">解除绑定</a>
                        </span>
                    </div>

                    <a class="li_right" href="javaScript:void(0)" v-if="!user.unionid || user.unionid == ''"
                        @click.stop="dindingWX">绑定微信</a>
                </div>
            </div>
        </div>
        <!-- 登录 -->
        <Login ref="login" @getUser="getUser"></Login>
    </div>
    </div>
</template>

<script>
    import Login from '@/components/assembly/Login.vue';//登录模块
    export default {
        name: 'popup',
        data() {
            return {
                user: {},//用户信息

            }
        },
        components: {
            Login
        },
        props: {

        },
        watch: {

        },
        methods: {
            remove_dinding() {//解除绑定
                let that = this;
                layer.open({
                    content: '您确定要解除微信绑定吗？'
                    , style: 'background-color:#fef0f0; color:#F56C6C;font-size:18px; border:none;' //自定风格
                    , btn: ['确定', '取消']
                    , yes: function (index) {
                        // location.reload();
                        layer.close(index);
                        that.$post('rebind', {
                            member_id: that.USER().id,
                        }).then(res => {
                            layer.open({
                                content: '解绑成功'
                                , time: 1
                                , skin: 'msg'
                            });
                            that.getUser();
                        })


                    }
                });
            },
            dindingWX() {
                this.$get('pc_code', {
                    member_id: this.USER().id
                }).then(res => {
                    window.location.href = res.data.data;

                }).catch(res => {
                     
                    layer.open({
                        content: res.message,
                        time: true,
                        skin: "msg"
                    });
                })
            },
            dindingFun() {
                this.$refs.login.loginFun(4);
            },
            modify() {
                this.$refs.login.loginFun(7);
            },
            geHome: function () {
                this.$router.replace('/');
            },
            getUser() {
                let that = this;
                this.REFRESH_USER();

                that.user = this.USER();

            },


        },
        mounted() {
            this.getUser();
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .div_title {
        border-bottom: 1px solid #DFDFDF;
    }

    .div_title .title {
        font-size: 16px;
        color: #1a1a1a;
        margin-bottom: 10px;
    }

    .members {
        padding: 20px 0;
        align-items: flex-start;
    }

    .members .members_li {
        height: 80px;
        border-bottom: 1px solid #bbb;
        align-items: center;
    }

    .members .members_li .li_left .li_title {
        width: 120px;
        font-size: 16px;
        color: #333;
        margin-right: 10px;
        display: inline-block;
    }

    .members .members_li .li_text {
        font-size: 16px;
        color: #333;
    }

    .members .members_li .wx {
        width: 45px;
        height: 45px;
        margin-right: 10px;
        border-radius: 50%;
        overflow: hidden;
    }

    .members .members_li .li_right {
        color: #ff0000;
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/pc_viwe/my_setUp.vue